// extracted by mini-css-extract-plugin
export default {"teamMember":"TeamMember_teamMember__8VoYl","memberDetails":"TeamMember_memberDetails__yeJ6M"};